import React, { useEffect, useState } from "react";
import "./assets/styles/app.css";
import Home from "./pages/Home";
import Header from "./components/Header";
import Experience from "./pages/Experience";
import Skills from "./pages/Skills";
import Contact from "./pages/Contact";
import Education from "./pages/Education";
import Loading from "./pages/Loading";
import Footer from "./components/Footer";

function App() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        window.history.scrollRestoration = "manual";
        return () => {
            window.history.scrollRestoration = "auto";
        };
    }, []);

    return (
        <div className="app">
            <a className="skip-link" href="#main">
                Skip to content
            </a>
            {isLoading ? <Loading onDone={() => setIsLoading(false)} /> : null}
            <Header />
            <main id="main">
                <Home />
                <Education />
                <Skills />
                <Experience />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}

export default App;
